module.exports = __webpack_public_path__ + "img/iforce.bf699824.jpg";